/* eslint-disable */
<template>
  <div class="surveys-page survey-container">
    <div>
      <div class="body-surveys">
          <div class="list-surveys">
              <div v-for="(item, index) in surveys" @click="handleClickSurveyItem(item)" class="survey-item" :key="index">
                  <div class="title-survey">
                      {{item.title}}
                  </div>
                  <div class="date-survey">
                    {{dateFormat(item.created_at)}}
                  </div>
                  <div v-if="item.is_complete" class="alert-complete-survey">済み</div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import { CAN_SHOW_SURVEY } from '@/config'

export default {
  data () {
    return {
      selectedSurvey: {}
    }
  },
  computed: {
    ...mapGetters({
      surveys: 'surveys/surveys'
    }),
    canShowSurvey () {
      return CAN_SHOW_SURVEY.indexOf(this.$auth.user().authority) !== -1
    }
  },
  methods: {
    ...mapActions({
      getSurveys: 'surveys/getSurveys',
      setNavigatorLinks: 'navigator/setLinks',
      setNavigatorTitle: 'navigator/setTitle'
    }),
    handleClickSurveyItem (surveyItem) {
      this.$router.push({path: `surveys/${surveyItem.id}`})
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  },
  async mounted () {
    if (this.canShowSurvey) {
      await this.getSurveys({company_code: this.$auth.user().company_code, status: 1})
    }
    this.setNavigatorLinks([])
    this.setNavigatorTitle('アンケート')
  }
}
</script>
<style>
  .el-select-dropdown.el-popper {
    width: calc(100% - 50px);
  }
</style>


// WEBPACK FOOTER //
// src/screens/surveys/index.vue